import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import formatCurrency from 'format-currency';

import OpenEyeIcon from '../../icons/OpenEyeIcon';
import ClosedEyeIcon from '../../icons/ClosedEyeIcon';

import { addFreeModeRoomToCart } from '../../../actions/FreeModeCart';
import { getLangValue } from '../../../utils/Generic';
import { CALL_CENTER_ROLE, LOYALTY_COINS_DISABLED } from '../../../constants';
import { setCoinsApplied, LOYALTY_STATUS } from '../../../actions/Loyalty';
import {
  checkExtrasByRoom, setExtrasAvailId, setExtrasByRoomSelected,
} from '../../../actions/Extras';
import withNavigate from '../../../withNavigate'; // Importa el HOC
//import { store } from '../../../Store';
import { getUpperLimit, convertirMoneda } from '../utils';
import LoyaltyUserRate from '../../loyalty/LoyaltyUserRate';

/* The amount "0.001" indicates a free booking, it cannot be any other value */
const validAmountRegexp = /^(\d+(\.\d{1,2})?|0\.001)$/;

class FreeModeRateOption extends React.Component {
  constructor(props) {
    super(props);

    this._isMounted = false;

    this.state = {
      showDetails: false, // toggle rate description, etc
      buttonLabel: 'select', // text key that the button should render
      originalBoard: props.rateOption.board,
      customAmount: null, // 0 could be a valid price, so we'll use "null" as not set
      customAmountValid: true,
      customAmountSubmitError: false,
    };

    this.toggleShowDetails = this.toggleShowDetails.bind(this);
    this.addItemToCart = this.addItemToCart.bind(this);
    this.changeRatePrice = this.changeRatePrice.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  toggleShowDetails() {
    if (this._isMounted) {
      this.setState({ showDetails: !this.state.showDetails });
    }
  }

  initShowAddingToCart() {
    // We go back to the "select" text after the room has been added
    if (this._isMounted) {
      this.setState({ buttonLabel: 'added' });
      this.setState({ customAmount: null });
      setTimeout(() => {
        this.setState({ buttonLabel: 'select' });
      }, 1200);
    }
  }

  changeRatePrice(e) {
    const customAmount = e.target.value;
    const customAmountValid = validAmountRegexp.test(customAmount) && customAmount > 0;
    if (this._isMounted) {
      this.setState({ customAmount, customAmountValid });
    }
  }

  showInvalidCustomPrice() {
    // We will show the message that the price has been reverted for a short period of time
    if (this._isMounted) {
      this.setState({ customAmount: null, customAmountSubmitError: true, customAmountValid: false }, () => {
        setTimeout(() => {
          this.setState({ customAmountSubmitError: false, customAmountValid: true });
        }, 2250);
      });
    }
  }

  applyMaxCoins(price) {
    const { maxPercentUsage, memberInfo, coinsForRegistering } = this.props.loyalty;
    let availableCoins = coinsForRegistering;
    if (memberInfo) {
      availableCoins = memberInfo.availableCoins;
    }
    const maxDiscount = Math.floor((price * maxPercentUsage) / 100, 1);

    if (availableCoins > maxDiscount) {
      this.props.setCoinsApplied(getUpperLimit(this.props));
    } else if (availableCoins <= maxDiscount) {
      //acá deberiamos poner el max_coins_allowed, sino poner 0
      /*let availableCoinsAvoidError = 0;
      const state1 = store.getState();
      if (state1.loyalty.memberInfo != null) {
        if (state1.loyalty.memberInfo.maxCoinsAllowed != null) {
          availableCoinsAvoidError = state1.loyalty.memberInfo.maxCoinsAllowed;
        }
      }*/
      this.props.setCoinsApplied(getUpperLimit(this.props));
    }
  }

  async addItemToCart() {
    let rateOption;
    const { customAmount } = this.state;
    if (customAmount === null) {
      rateOption = this.props.rateOption;
      //this.applyCoins2Total(rateOption.rate.price_from);
      //Ya no es necesario
    } else if (validAmountRegexp.test(customAmount) && customAmount > 0) {
      // El monto se captura en la moneda seleccionada en el Header (userCurrency), pero el
      // backend siempre espera el customAmount en la moneda de la tarifa, así que lo convertimos
      // antes de mandarlo al carrito. "0.001" es un valor especial (booking gratis) y no se convierte.
      const rateCurrency = this.props.rateOption.rate.currency;
      const editedCurrency = this.props.userCurrency.code;
      let customAmountInRateCurrency = customAmount;
      if (customAmount !== '0.001' && editedCurrency !== rateCurrency) {
        // OJO: no usamos convertirMoneda() aquí porque esa función redondea a 2 decimales en el
        // paso intermedio (a USD). Como el carrito vuelve a convertir ese monto a la moneda
        // seleccionada para mostrarlo, ese doble redondeo hacía que, por ejemplo, 100 MXN
        // terminara mostrándose como 100.02 MXN en el carrito. Convertimos "a mano" sin redondear
        // el paso intermedio, para que al reconvertir de vuelta el monto coincida exacto.
        const { conversionRates } = this.props;
        const origen = conversionRates.find((rate) => rate.currency_code === editedCurrency);
        const destino = conversionRates.find((rate) => rate.currency_code === rateCurrency);
        const amountInRateCurrency = (Number(customAmount) / origen.value) * destino.value;
        customAmountInRateCurrency = amountInRateCurrency.toFixed(6);
      }
      rateOption = { ...this.props.rateOption, customAmount: customAmountInRateCurrency };
      //this.applyCoins2Total(customAmount);
      //Ya no es necesario
    } else {
      // Zero will be shown as invalid price, for Zero they need to enter 0.001
      this.showInvalidCustomPrice();
      return;
    }
    const roomId = (this.props.cart.cartHotel.rooms.length + 1).toString();
    if (this._isMounted) {
      this.setState({ buttonLabel: 'adding', customAmountSubmitError: false, customAmountValid: true });
    }
    this.props.addFreeModeRoomToCart(rateOption).then(async (success) => {
      if (success) {
        this.initShowAddingToCart();
        await this.checkExtras(rateOption, roomId);
        if (this.props.loyalty.memberInfo != null) {
          await this.props.checkMember(this.props.loyalty.memberInfo.email);
        }
      } else if (this._isMounted) {
        this.setState({ buttonLabel: 'select' });
      }
    });
  }

  async checkExtras(selectedRate, roomId) {
    const { room, rate, board } = selectedRate;
    const roomCode = room.code;
    const boardCode = board.code;
    const rateCode = rate.code;
    const { use_requested } = room;
    //const roomId = MULTIPLE_ROOMS.FIRST; //El problema acá es que siempre le mandan el roomId=1 y si elige vario cuartos, los extras siempre se los pondría al roomId1
    const { selectedStatus, memberInfo } = this.props.loyalty;
    const { BECOME_MEMBER, IS_MEMBER } = LOYALTY_STATUS;
    const isLoyalty = selectedStatus === BECOME_MEMBER || !!(selectedStatus === IS_MEMBER && memberInfo.accountHolder);
    if (roomId === 1) {
      // Puse esta validación porque cuando el usuario de call center, elige más de un cuarto, después de elegir el
      //primer cuarto, cuando eligen el segundo por ejemplo, se borran los extras que ya se consultaron para el
      //cuarto 1, eso causaba que sólo se mostraran extras para el último cuarto elegido
      this.props.setExtrasAvailId(null);
      this.props.setExtrasByRoomSelected(null);
    }
    await this.props.checkExtrasByRoom({
      roomCode, boardCode, rateCode, distribution: use_requested, roomId, isLoyalty,
    });
    /*if (response.extrasAvailable) {
      this.extrasRedirect();
    }*/
    // Cuando el usuario estaba logeado como callcenter
    // y seleccionaba un carto, se cargaban los extras pero había ese redirect, lo cual no estaba bien
    // ya que el usuario ya no podía poner la cuenta de loyalty para que se redimieran los coins
  }

  extrasRedirect() {
    this.props.navigate('/select-extra/');
  }

  applyCoins2Total(amount) {
    if (this.props.showLoyalty === LOYALTY_COINS_DISABLED) {
      this.props.setCoinsApplied(0);
      return;
    }
    if (this.props.cart.cartHotel.isEmpty) {
      this.applyMaxCoins(amount);
    } else {
      const currencyCode = this.props.userCurrency.code;
      this.applyMaxCoins(parseFloat(amount, 10) + this.props.cart.amount[currencyCode]);
    }
  }

  getUserCurrencyAmounts(board) {
    const currencyCode = this.props.userCurrency.code;
    return board.amount[currencyCode];
  }

  getHotelCurrency() {
    const code = this.props.currentHotel.default_currency;
    return this.props.currentHotel.currencies.find((currency) => currency.code === code);
  }

  renderDetails(rate, board) {
    return (
            <div className={`rate__description ${this.state.showDetails ? '' : 'd-none'}`}>
              <p>{rate.description}</p>
              <p>{getLangValue(board, this.props.lang, 'boardDescription')}</p>
            </div>
    );
  }

  renderDetailToggle() {
    const icon = this.state.showDetails ? <ClosedEyeIcon/> : <OpenEyeIcon/>;
    const title = this.state.showDetails ? this.context.t('hide details') : this.context.t('show details');
    return (
            <div className="rate__showmore" onClick={this.toggleShowDetails}>
              {icon}
              {title}
            </div>
    );
  }

  renderUnitsInCart() {
    // Show the number of units in the cart.
    // The match is for same: room, rate, board AND occupancy
    const units = this.props.cart.cartHotel.rooms.filter((cartRoom) => (
      cartRoom.optionId === this.props.rateOption.optionId
    )).length;
    if (units === 0) {
      return null;
    }
    return (
            <span className="mx-1 text-cyan font-weight-normal text-lowercase">
        {this.context.t('{items} in basket', { items: units })}
      </span>
    );
  }

  renderDiscount(board) {
    const userAmounts = this.getUserCurrencyAmounts(board);
    if (userAmounts.discount === 0) {
      return null;
    }
    return (
            <React.Fragment>
              <div className="price__default">
                {this.renderPrice(userAmounts, 'amount_before')}
              </div>
              <div className="price__percent">
                {userAmounts.discount} %
              </div>
            </React.Fragment>
    );
  }

  renderPrice(amounts, fieldName) {
    return formatCurrency(amounts[fieldName], this.props.userCurrency);
  }

  renderEditablePrice(board) {
    // Los usuarios de call center quieren capturar el precio personalizado en la moneda que
    // tengan seleccionada en el selector de currency del Header (filterCurrency/userCurrency),
    // ya no siempre en la moneda de la tarifa/hotel. Como board.amount ya trae los montos en
    // todas las monedas disponibles, sólo tomamos el monto correspondiente a esa moneda.
    const rateCurrency = this.props.rateOption.rate.currency;
    const currency = this.props.userCurrency.code;
    let amountStr = this.state.customAmount;
    if (amountStr === null) { // 0 could be a valid amount
      const { usedCoins } = this.props;
      const { amount } = board.amount[currency];
      // Los coins usados vienen expresados en la moneda de la tarifa, así que los convertimos
      // a la moneda seleccionada antes de restarlos
      const usedCoinsInSelectedCurrency = usedCoins && currency !== rateCurrency
        ? convertirMoneda(this.props, usedCoins, rateCurrency, currency)
        : usedCoins;
      if (usedCoinsInSelectedCurrency && usedCoinsInSelectedCurrency > 0
        && this.props.cart.cartHotel.rooms.length === 0) {
        amountStr = Number(amount - usedCoinsInSelectedCurrency).toFixed(2);
      } else {
        amountStr = Number(amount).toFixed(2);
      }
      if (amountStr < 0) {
        amountStr = 0;
      }
    }

    const validClass = this.state.customAmountValid ? '' : ' price__current--invalid';
    return (
            <div className={`price__current price__current--editable${validClass}`}>
              <input type="text" value={amountStr} pattern="[0-9\.,]" onChange={this.changeRatePrice}/>
              {currency}
              {this.state.customAmountSubmitError
              && <small>{this.context.t('Please correct the price to select the room')}</small>
              }
            </div>
    );
  }

  renderLoyaltyUserRate(board) {
    if ((this.props.memberInfo != null && this.props.memberInfo.accountHolder != null)
      || this.props.selectedStatus === 'becomeMember') {
      return (
        <LoyaltyUserRate
          board={board}
          showJoinLoyaltyMessage={false}
        />
      );
    }
    return null;
  }

  renderRateOptionPrice(currencyAmounts) {
    if (this.props.isCallCenterUser) {
      return this.renderEditablePrice(currencyAmounts);
    }
    return this.renderPrice(currencyAmounts, 'amount');
  }

  getButtonLabel() {
    switch (this.state.buttonLabel) {
      case 'adding':
        return this.context.t('Adding...');
      case 'added':
        return `${this.context.t('Added')} ✓`;
      default:
        return this.context.t('Select');
    }
  }

  renderNotAvailableReason(rate) {
    if (rate.available) {
      return null;
    }

    let reason;
    if (rate.reason_not_available === 'NotStay') {
      reason = this.context.t('Not available: Minimum stay - {nights} nights', { nights: rate.minimum_stay });
    } else {
      reason = this.context.t('Not available: {reason}', { reason: rate.reason_not_available });
    }
    return (
            <div className="rate__name--unavailable">
              {reason}
            </div>
    );
  }

  renderSelectButton() {
    const disabledClass = this.props.cart.isUpdating ? ' btn-primary--disabled' : '';
    return (
            <button className={`btn btn-primary rounded-0 text-uppercase h4 font-weight-bold${disabledClass}`}
                    onClick={this.addItemToCart}>
              {this.getButtonLabel()}
            </button>
    );
  }

  renderUserCurrencyAmount(board) {
    if (this.props.isCallCenterUser) {
      // Para call center, el precio editable (renderEditablePrice) ya se muestra y se captura
      // en la moneda seleccionada (userCurrency), así que este renglón adicional sería redundante
      return null;
    }
    // TEMA VisualicacionTarifasEnDiversasCurrenciesParaCallCenter
    // Se pidió que los usuarios de call center puedan filtrar por varias currencies
    // para ver visualmente los montos. Anteriormente cuando el usuario de call center
    // filtraba por algún currency, también con eso se seteaba ese currency como
    // el payment currency.
    // Pidieron que los usuarios de DIRECTOS CALL CENTER pudieran ver las tarifas en MXN, igual los de DIRECTOS CALL CENTER MÉXICO,
    // que puedan ver las tarifas en cualquier moneda, por lo que se comenta todo el siguiente if
    /*if (this.props.currentHotel.default_currency === this.props.userCurrency.code
      || this.props.userCurrency.code === this.props.rateOption.rate.currency) {
      return null;
    }*/
    // Le quitamos la primera condición para que quede de la siguiente manera:
    if (this.props.userCurrency.code === this.props.rateOption.rate.currency) {
      return null;
    }
    const rateCurrency = this.props.rateOption.rate.currency;
    // Es el currency en el que viene el rate, como ya se dolarizó el front motor, usamos siempre
    // DIRECTOS CALL CENTER, entonces rateCurrency será 'USD'
    const userAmounts = this.getUserCurrencyAmounts(board);
    const { customAmount } = this.state;
    let amountToDisplay = userAmounts.amount;
    if (customAmount != null) {
      amountToDisplay = convertirMoneda(this.props, customAmount, rateCurrency, this.props.userCurrency.code);
    }
    return (
            <div className="col-xs-12 col-md-7">
              <div className="text-right font-weight-bold converted-price">
                {formatCurrency(amountToDisplay, this.props.userCurrency)}
              </div>
            </div>
    );
  }

  renderRateCode() {
    if (!this.props.isCallCenterUser) {
      return null;
    }
    const { rate } = this.props.rateOption;
    return (
            <small className="d-block">{this.context.t('Rate code: {code}', { code: rate.code })}</small>
    );
  }

  render() {
    const { board, rate } = this.props.rateOption;
    return (
            <div className="row">
              <div className="col-xs-12">
                {this.renderNotAvailableReason(rate)}
              </div>
              <div className="col-xs-12">
                <div className="rate">
                  <div className="rate__name">
                    {getLangValue(rate, this.props.lang, 'name')}
                    {this.renderRateCode()}
                    {this.renderUnitsInCart()}
                  </div>
                  {this.renderDetailToggle()}
                </div>
              </div>
              <div className="col-xs-12">
                <div className="price">
                  {this.renderDiscount(board)}
                  {this.renderRateOptionPrice(board)}
                  {this.renderSelectButton()}
                </div>
                <div className='price'>
                  {this.renderLoyaltyUserRate(board)}
                </div>
              </div>
              {this.renderUserCurrencyAmount(board)}
              <div className="col-xs-12 my-2">
                <div className="border-bottom">
                  {this.renderDetails(rate, board)}
                </div>
              </div>
            </div>
    );
  }
}

FreeModeRateOption.propTypes = {
  rateOption: PropTypes.object.isRequired,
  _isMounted: PropTypes.bool,
  navigate: PropTypes.func.isRequired, // Prop para `navigate`
  checkMember: PropTypes.func.isRequired,
};

FreeModeRateOption.contextTypes = {
  t: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  lang: state.i18nState.lang,
  chain: state.bookingFormState.chain,
  currentHotel: state.booking.hotel,
  hotel: state.booking.hotel,
  userCurrency: state.booking.filterCurrency,
  currency: state.booking.filterCurrency,
  isCallCenterUser: state.session.user.role === CALL_CENTER_ROLE,
  loyalty: state.loyalty,
  loyaltyName: state.session.chainData.booking_engine_configuration.loyalty_name,
  openReservationDetails: state.session.openReservationDetails,
  shouldShowNewShoppingCartMobileHeader: !!(window.location.pathname === '/rooms/'
    || window.location.pathname === '/confirmation/'),
  multipleRoomStep: state.booking.multipleRoomStep,
  multipleRoomSelection: state.booking.multipleRoomSelection,
  nights: state.booking.last_requested_info.nights,
  isCreatingBooking: state.session.isCreatingBooking,
  distributions: state.bookingFormState.distributions.length > 0
    ? state.bookingFormState.distributions
    : state.cart.cartHotel.rooms.map((room) => room.distribution),
  coinsApplied: state.loyalty.coinsApplied,
  coinsEntered: state.loyalty.coinsEntered,
  new_member: state.loyalty.newMember,
  new_member_discount_percentage: state.loyalty.newMemberDiscountPercentage,
  new_member_discount_percentage_activated: state.booking.hotel != null
    ? (state.booking.hotel.new_member_discount_percentage_activated === true
      && state.bookingFormState.agentSell === 'false') : false,
  isCartUpdating: state.cart.isUpdating,
  currencies: state.booking.currencies,
  loggedUser: state.loyalty.loggedUser,
  memberInfo: state.loyalty.memberInfo,
  maxPercentUsage: state.loyalty.maxPercentUsage,
  promoCode: state.bookingFormState.promoCode,
  cart: state.cart,
  conversionRates: state.loyalty.conversionRates,
  showLoyalty: state.session.chainData.loyalty_coins_active,
  selectedStatus: state.loyalty.selectedStatus,
  agentCode: state.bookingFormState.agentCode,
  agentSell: state.bookingFormState.agentSell,
});

const mapDispatchToProps = (dispatch) => ({
  addFreeModeRoomToCart: (payload) => dispatch(addFreeModeRoomToCart(payload)),
  checkExtrasByRoom: (payload) => dispatch(checkExtrasByRoom(payload)),
  setCoinsApplied: (payload) => dispatch(setCoinsApplied(payload)),
  setExtrasAvailId: (payload) => dispatch(setExtrasAvailId(payload)),
  setExtrasByRoomSelected: (payload) => dispatch(setExtrasByRoomSelected(payload)),
});

const ConnectedFreeModeRateOption = connect(mapStateToProps, mapDispatchToProps)(FreeModeRateOption);

// Exportar el componente envuelto con el HOC
export default withNavigate(ConnectedFreeModeRateOption);
